// src/components/sections/AccommodationsSection/AccommodationsSection.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AccommodationsSection.css';
import { rooms } from '../../../data/roomsData';
import FeatureIcon from '../../FeatureIcon/FeatureIcon';

const AccommodationsSection = () => {
  return (
    <section id="acomodacoes" className="section accommodations-section">
      <div className="container">
        {/* --- CABEÇALHO ATUALIZADO para o Hotel Imperial e SEO --- */}
        <div className="section-header">
          <span className="section-eyebrow">Onde Descansar</span>
          <h2 className="section-title">Acomodações no Coração de São Lourenço</h2>
          <p className="section-subtitle">
            Escolha entre nossas opções de hospedagem: confortáveis quartos Duplos, Triplos e Quádruplos. Desfrute de diárias com café da manhã incluso, ou opte pela pensão completa para uma experiência gastronômica ainda mais rica em sua estadia no centro de São Lourenço.
          </p>
        </div>

        <div className="rooms-grid">
          {rooms.map(room => (
            <RoomCard key={room.id} room={room} />
          ))}
        </div>
      </div>
    </section>
  );
};

// O componente RoomCard agora tem a lógica do carrossel automático
const RoomCard = ({ room }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    // Se não houver mais de uma imagem, não faz nada
    if (room.images.length <= 1) return;

    // Define um timer para trocar de imagem a cada 4 segundos
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === room.images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // 4000ms = 4 segundos

    // Limpa o timer quando o componente é desmontado para evitar vazamento de memória
    return () => clearInterval(timer);
  }, [room.images.length]);

return (
    // --- ALTERAÇÃO 1: O container principal agora é um <Link> ---
    <Link to={`/acomodacoes/${room.type.toLowerCase()}`} className="room-card">
      <div className="room-image-container">
        {room.images.map((image, index) => (
          <img 
            key={index}
            src={image} 
            alt={`${room.title} - Foto ${index + 1}`} 
            className={`room-image ${index === currentImageIndex ? 'active' : ''}`} 
          />
        ))}
        <div className="room-type-badge">{room.type}</div>
      </div>
      
      <div className="room-content">
        <h3 className="room-title">{room.title}</h3>
        <p className="room-description">{room.description}</p>
        <p className="room-capacity"><strong>Capacidade:</strong> {room.capacity}</p>
        
        <div className="room-features">
          <h4>Comodidades:</h4>
          <ul>
            {room.features.map((feature, index) => (
              <li key={index}>
                <span className="feature-icon">
                  <FeatureIcon iconName={feature.icon} />
                </span>
                <span>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="card-footer">
          {/* --- ALTERAÇÃO 2: O Link agora é um <div> para não aninhar links --- */}
          <div className="btn btn-secondary">
            Ver Mais Detalhes
          </div>
        </div>
      </div>
    </Link>
  );
};

export default AccommodationsSection;